import { createSlice } from "@reduxjs/toolkit";
import { GrupoContaBancoModel } from "../../../models/grupoContaBanco/grupoContaBancoModel";
import { buscarGrupoContaBanco } from "../../../services/grupoContaBancoService";

export interface GrupoContaBancoState {
  //buscar grupo conta banco
  loading: boolean;
  list: GrupoContaBancoModel[];
  entity: GrupoContaBancoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: GrupoContaBancoState = {
  //buscar grupo conta banco
  loading: false,
  list: [],
  entity: {} as GrupoContaBancoModel,

  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const grupoContaBancoSlice = createSlice({
  name: "grupoContaBanco",
  initialState,
  reducers: {
    //buscar grupo conta banco
    setEntityGrupoContaBanco: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarGrupoContaBanco: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarGrupoContaBanco: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase("resetAll", () => initialState);

    //buscar grupo conta banco
    builder.addCase(buscarGrupoContaBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarGrupoContaBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarGrupoContaBanco.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar grupo conta banco
  setEntityGrupoContaBanco,
  //internal
  setModalCadastrarGrupoContaBanco,
  setModalDeletarGrupoContaBanco,
} = grupoContaBancoSlice.actions;

export default grupoContaBancoSlice.reducer;
